<div class="dialog-header">
  <h3 mat-dialog-title mat-dialog-draggable-title>
    {{ jobStatus.jobName }} ({{ jobDate() }}) - Distribution Data
  </h3>
  <span aria-hidden="true" (click)="onNoClick()">&times;</span>
</div>

<mat-dialog-content>
  <app-distribution-container *ngIf="distributionContainerConfig != null" [config]="distributionContainerConfig"></app-distribution-container>
</mat-dialog-content>
